import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TransactionInput, UserMeta} from "../../../modules/models/types";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import {FaceSDK} from "@identy/identy-face";

@Component({
  selector: 'app-user-input',
  templateUrl: './user-input.component.html',
  styleUrls: ['./user-input.component.css']
})
export class UserInputComponent implements OnInit {
  public user_name: UserMeta;
  public users_list: Array<UserMeta> = [];
  constructor(public dialogRef: MatDialogRef<UserInputComponent>,
              @Inject(MAT_DIALOG_DATA) public dialog_data: TransactionInput) { }

  public optionSelected: boolean = false;
  ngOnInit(): void {
    this.user_name = {
      unique_user_id: "",
      username: "",
      creation_date: 0
    }
    const users_str = localStorage.getItem("FACE_UIL");
    if(users_str != void 0) {
      this.users_list = JSON.parse(users_str) as Array<UserMeta>;
    }
  }

  async close() {
    if (this.user_name.username === "") {
       alert("A name is required");
       return;
    }

    if(this.user_name.unique_user_id === "") {
      this.user_name.unique_user_id = this.user_name.username + "_" +new Date().getTime();
      this.user_name.creation_date = new Date().getTime();
      this.users_list.push(this.user_name);
      localStorage.setItem("FACE_UIL", JSON.stringify(this.users_list));
      localStorage.removeItem("FACE_IM");
    }

    const session = localStorage.getItem("FACE_IM");
    const current_meta = await FaceSDK.get_meta_data();
    const stored_install: any = JSON.parse(session) as any;
    if(stored_install == null || stored_install['commit'] != current_meta.commit) {
      localStorage.setItem("FACE_IM", JSON.stringify(current_meta));
    }

    if (this.dialog_data.onclose) {
      this.dialog_data.onclose(this.user_name);
    }
    this.dialogRef.close();
  }

  show_fn(value: any) {
    if(value == null || value === "") {
      return "";
    }
    if(typeof value === "string") {
      return value;
    }
    return value.username;
  }

  option(event: MatAutocompleteSelectedEvent) {
    this.user_name = event.option.value;
    this.optionSelected = true;
  }

}
